import ActiveRecord from './active_record/base'
import utils from '@eitje/utils'

class RevenueGroup extends ActiveRecord {
	static tableName = 'omzetGroepen'
	static defaultJoins = ['integrationExtRevenueGroups']
	static sort = 'naam'

	integrated() {
		return utils.exists(this.integration_ext_revenue_group_ids)
	}
}

export default RevenueGroup
